import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import store from '@redux';
import { Routes } from '@router';
import Boot from './boot';
import {
  lightTheme,
  GlobalStyles,
} from '@styles';
import { GoogleOAuthProvider } from "@react-oauth/google";

const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

function App() {

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Provider store={store}>
        <ThemeProvider theme={lightTheme}>
          <GlobalStyles />
          <Routes />
        </ThemeProvider>
      </Provider>
    </GoogleOAuthProvider>
  );
}

Boot()
  .then(() => { })
  .catch(error => console.error(error));

export default App;
